import cx from 'classnames'
import Form from 'react-bootstrap/Form'

import Typography from '../../Typography/Typography'

import './Checkbox.scss'

const Checkbox = ({ label, onChange, error, color = 'blue', errorText, onBlur, touched, id, className, ...props }) => {
    return (
        <Form.Group className={cx('checkbox', className)}>
            <Form.Check isInvalid={error} className={'d-flex align-items-center gap-3'}>
                <Form.Check.Input
                    type={'checkbox'}
                    id={id}
                    isInvalid={error && touched}
                    className={`checkbox--${color} rounded-0`}
                    onChange={onChange}
                    onBlur={onBlur}
                    {...props}
                />
                {label && (
                    <label>
                        <Typography
                            color={(error && touched && 'error') || (color === 'white' && 'basePrimary') || 'primary'}
                            variant={'formLabel'}
                        >
                            {label}
                        </Typography>
                    </label>
                )}
            </Form.Check>
            {error && touched && (
                <Form.Control.Feedback type={'invalid'} className={cx(error && 'd-block m-0')}>
                    <Typography variant={'formDescription'} color={'error'} className={'position-absolute'}>
                        {error}
                    </Typography>
                </Form.Control.Feedback>
            )}
        </Form.Group>
    )
}

export default Checkbox
